// Esc 한 번에 가장 위에 열린 겹침창(사진 뷰어, 사용량 창, 화면 공유 크게 보기, 반응 팔레트, 채팅 입력)만 닫는다.
// 게임의 일시정지(Esc)로 가지 않게 입력(input.js)이 그 키를 보지 않도록 G.keyGuard로 알린다: 입력 쪽 리스너가 먼저 돌든 나중에 돌든 같게, 닫은 뒤에도 그 이벤트는 막는다.
const G = (window as any).G;
type Layer = { isOpen: () => boolean; close: () => void };
const layers: Layer[] = [];   // 앞에 있을수록 먼저 닫힌다
let swallowed: KeyboardEvent | null = null;
export function onEscape(layer: Layer) { layers.unshift(layer); }
// 키를 입력 칸이 쓰고 있을 때(채팅 입력 중)는 게임이 어떤 키도 받지 않는다: addKeyGuard
const guards: ((e: KeyboardEvent) => boolean)[] = [];
export function addKeyGuard(f: (e: KeyboardEvent) => boolean) { guards.push(f); }
G.keyGuard = (e: KeyboardEvent) => e === swallowed || (e.code === 'Escape' && layers.some((l) => l.isOpen())) || guards.some((f) => f(e));
window.addEventListener('keydown', (e) => {
  if (e.code !== 'Escape') return;
  const top = layers.find((l) => l.isOpen());
  if (!top) return;
  swallowed = e; e.preventDefault(); e.stopImmediatePropagation();
  top.close();
}, true);
